module.exports = __webpack_public_path__ + "static/img/icon_xiao@2x.10dc06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software/icon_xiao@2x.png
// module id = 67
// module chunks = 0